
import { Content, Header, Page } from '@backstage/core-components';

import {
  ClockConfig,
  CustomHomepageGrid,
  HeaderWorldClock,
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageTopVisited,
  LayoutConfiguration,
  WelcomeTitle,
  homePlugin,
} from '@backstage/plugin-home';

import { createComponentExtension } from '@backstage/core-plugin-api';

export const HomeOwnershipCard = homePlugin.provide(
  createComponentExtension({
    name: 'HomeOwnershipCard',
    component: {
      lazy: () =>
        import('../HomeWidgets/EntityOwnershipForm').then(
          m => m.OwnershipCardWidget,
        ),
    },
  }),
);

export const HomeToolBoxCard = homePlugin.provide(
  createComponentExtension({
    name: 'HomeToolBoxCard',
    component: {
      lazy: () =>
        import('../HomeWidgets/EntityToolBoxCard').then(
          m => m.ToolBoxCardWidget,
        ),
    },
  }),
);

export const HomeKubernetesCard = homePlugin.provide(
  createComponentExtension({
    name: 'HomeKubernetesCard',
    component: {
      lazy: () =>
        import('../HomeWidgets/EntityKubernetesCard').then(
          m => m.KubernetesCardWidget,
        ),
    },
  }),
);

export const HomePage = () => {
  const clockConfigs: ClockConfig[] = [
    {
      label: 'LIMA',
      timeZone: 'America/Lima',
    },
    {
      label: 'NJ',
      timeZone: 'America/New_York',
    },
  ];

  const timeFormat: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  const defaultConfig: LayoutConfiguration[] = [
    {
      component: 'HomePageRecentlyVisited',
      x: 0,
      y: 2,
      width: 6,
      height: 17,
    },
    {
      component: 'HomePageTopVisited',
      x: 6,
      y: 2,
      width: 6,
      height: 17,
    },
    {
      component: 'HomeOwnershipCard',
      x: 0,
      y: 17,
      width: 12,
      height: 20,
    },
    {
      component: 'HomeToolBoxCard',
      x: 0,
      y: 37,
      width: 12,
      height: 20,
    },
    {
      component: 'HomeKubernetesCard',
      x: 0,
      y: 57,
      width: 12,
      height: 40,
    },
  ];

  return (
    <Page themeId="home">
      <Header
        title={<WelcomeTitle language={['English']} variant="h3" />}
        pageTitleOverride="Home"
      >
        <HeaderWorldClock
          clockConfigs={clockConfigs}
          customTimeFormat={timeFormat}
        />
      </Header>
      <Content>
        <CustomHomepageGrid
          config={defaultConfig}
          rowHeight={10}
          compactType="vertical"
        >
          <HomePageRecentlyVisited kind="recent" numVisitsOpen={4} />
          <HomePageTopVisited numVisitsOpen={4} />
          <HomePageStarredEntities title="Favorites" groupByKind />
          <HomeOwnershipCard />
          <HomeToolBoxCard />
          <HomeKubernetesCard />
        </CustomHomepageGrid>
      </Content>
    </Page>
  );
};
